module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"remove":"Remove image","remove_desc":"Remove your current profile image.","image":"Upload image","image_desc":"Use any photo from your device."},"de":{"remove":"Bild entfernen","remove_desc":"Das aktuelle Profilbild entfernen.","image":"Bild hochladen","image_desc":"Nutze ein beliebiges Foto von deimem Gerät"}}')
  delete Component.options._Ctor
}
